// import type {FileApiModel} from '@yourcoach/shared/api/media/file';
import type {ProgramExpandedCommon} from '@yourcoach/shared/api/program';

// import type {Expand, MaybeExpanded} from '@yourcoach/shared/api/types';
// import type {User, UserExpanded} from '@yourcoach/shared/api/user';
// import {userExpandCommon} from '@yourcoach/shared/api/user';
//
// import type {ScheduleMaterial} from '@src/modules/materials/utils';
import {programExpandCommon} from '@yourcoach/shared/api/program';

// export const expand: Expand = {
//   program: [
//     'avatar_id',
//     'background_id',
//     [
//       'edition_ids',
//       null,
//       {
//         edition: [
//           'contract_id',
//           'materials.file_ids',
//           'tasks.coach_attachment_ids',
//         ],
//       },
//     ],
//     [
//       'coach_ids->expanded_coaches',
//       {name: 'Coach not found', coach_title: 'Coach not found'},
//       userExpand,
//     ],
//   ],
// };

// export const publicExpand: Expand = {
//   program: [
//     'avatar_id',
//     'background_id',
//     [
//       'edition_ids',
//       null,
//       {
//         edition: ['course_ids'],
//       },
//     ],
//     [
//       'coach_ids->expanded_coaches',
//       {name: 'Coach not found', coach_title: 'Coach not found'},
//       userExpand,
//     ],
//   ],
// };

// export type ExpandedCoach = (
//   | User
//   | (Partial<User> & Required<Pick<User, 'name' | 'coach_title'>>)
// ) &
//   UserExpanded;
//
// export interface Expanded {
//   avatar?: FileApiModel | null;
//   background?: FileApiModel | null;
//   editions: (
//     | (Omit<Edition, 'tasks'> & {
//         contract?: FileApiModel | null;
//         materials: ScheduleMaterial[];
//         tasks: (Edition['tasks'][0] & {
//           coach_attachments: MaybeExpanded<FileApiModel>[];
//         })[];
//       })
//     | undefined
//   )[];
//   expanded_coaches: ExpandedCoach[];
// }

export const expand = programExpandCommon;

export type Expanded = ProgramExpandedCommon;
